import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Box } from "reactjs-admin-lte";
import {
  Form,
  FormControl,
  FormGroup,
  ButtonToolbar,
  Button,
  InputGroup,
  Modal,
  ControlLabel,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import Select from "react-select";
import Moment from "moment";
import CKAutocomplete from "../../component/element/CKAutocomplete";
import FontAwesome from "react-fontawesome";
import DatePicker from "../../component/element/DatePicker";
import StockStore from "../../stores/StockStore";
import CashflowStore from "../../stores/CashflowStore";
import SearchCarButton from "../../component/element/SearchCarButton";
import IframeModal from "../../component/element/IframeModal";
import InputNumber from "rc-input-number";
import { momentHelper } from "../report/helpers";
import ConfirmPopup from "component/element/ConfirmPopup";
import "./CashFlow.css";
import $ from "jquery";
import XLSX from "xlsx";
import FileSaver from "file-saver";
import TextFieldModal from "component/element/TextFieldModal";
// import { Checkbox, Radio } from 'react-icheck'

var NotificationSystem = require("react-notification-system");

const DEFAULT_ROW = 1;
const yTh = parseInt(Moment().format("YYYY")) + 543;
const curMonth = parseInt(Moment().format("MM"));
const curDay = parseInt(Moment().format("DD"));

class CashFlowRecord extends Component {
  constructor(props) {
    super(props);

    const optionsDay = this.getOptionsDay(yTh, curMonth);
    const optionsYear = [];

    for (var i = yTh; i >= 2557; i--) {
      optionsYear.push({
        value: i,
        label: i,
      });
    }

    const optionsMonth = [
      { value: 1, label: "มกราคม" },
      { value: 2, label: "กุมภาพันธ์" },
      { value: 3, label: "มีนาคม" },
      { value: 4, label: "เมษายน" },
      { value: 5, label: "พฤษภาคม" },
      { value: 6, label: "มิถุนายน" },
      { value: 7, label: "กรกฎาคม" },
      { value: 8, label: "สิงหาคม" },
      { value: 9, label: "กันยายน" },
      { value: 10, label: "ตุลาคม" },
      { value: 11, label: "พฤศจิกายน" },
      { value: 12, label: "ธันวาคม" },
    ];

    this.state = {
      loading: false,
      showSave: true,
      optionsYear: optionsYear,
      optionsMonth: optionsMonth,
      optionsDay: optionsDay,
      defaultYear: yTh,
      defaultMonth: curMonth,
      defaultDay: 0, // curDay,
      data: [],
      deletedData: [],
      cashflowCate: [],
      cashflowCateAuto: [],
      cashflowValue: "",
      companyAuto: [],
      car_registration_no_list: [],
      showCar: false,
      car_index: 0,
      styleCarRegis: [],
      cateAction: "add",
      showCate: false,
      showAddCate: false,
      indexCategory: undefined,
      companyAction: "add",
      showCompany: false,
      showAddCompany: false,
      newCate: "",
      newCompany: "",
      indexCompany: undefined,
      perm: { perm_cashflow_admin: false, perm_add_category: false },
      isRange: false,
      defaultYearRange: yTh,
      defaultMonthRange: curMonth,
      defaultDayRange: curDay,
      showDoc: false,
      dataDoc: [],
      dataImg: { files: [] },
      showAddDoc: false,
      newDoc: "",
      itemnumdoc: undefined,
      docActive: { name: undefined, title: undefined },
      isShowDocEdit: true,
      isAction: "add",
      indexEdit: undefined,
      indexDel: undefined,
      showConfirm: false,
      isIncome: true,
      isExpense: true,
      activeIndex: [],
      isSave: true,
      showCancel: false,
    };

    this.pcInput = new Array(DEFAULT_ROW).fill("");
    this._description = new Array(DEFAULT_ROW).fill("");
    this.refTableId = "CashFlowRecord-" + Math.ceil(Math.random() * 100);
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    // this.loadCashflowRecord(this.state.defaultYear,this.state.defaultMonth,this.state.defaultDay,this.state.cashflowValue)
    // this.loadRecordCategory()
    // this.loadCompany()

    // $('body').on('click', ()=> {
    //   if ($('.Select').hasClass('is-open'))
    //     $('.table-responsive').css( "overflow-x", "initial" );
    //   else
    //     $('.table-responsive').css( "overflow-x", "auto" );
    // });

    $(".form-auto").on("focus", () => {
      $(".table-responsive").css("overflow-x", "initial");
    });
    $(".form-auto").on("keypress", (e) => {
      if (e.charCode === 13) $(".table-responsive").css("overflow-x", "auto");
    });
    $("body").on("click", ".ck-autocomplete-box", () => {
      $(".table-responsive").css("overflow-x", "auto");
    });
  }

  componentWillReceiveProps(newProps) {}

  setTableAuto() {
    $(".table-responsive").css("overflow-x", "auto");
  }

  setDateRange(date, year, month) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth();
    this.setState({
      defaultDayRange: all_day,
      defaultMonthRange: month,
      defaultYearRange: year,
    });
  }

  getOptionsDay(year, month) {
    let optionsDay = [];
    const all_day = Moment(year + "-" + month, "YYYY-MM").daysInMonth();
    for (var i = 0; i <= all_day; i++) {
      if (i == 0) {
        var label = "ทั้งเดือน";
      } else {
        var label = i;
      }
      optionsDay.push({
        value: i,
        label: label,
      });
    }
    return optionsDay;
  }

  loadCarRegistrationNo(index) {
    let { data, styleCarRegis } = this.state;
    let car = [];
    StockStore.loadCarRegistrationNoWithWork(
      data[index].car_registration_no,
      (result) => {
        styleCarRegis[index] = "";
        result.data.forEach((element) => {
          car.push({
            id: element.Value,
            label: element.Name,
            car_info: element.car_info,
            work_no: element.work_no,
            car_registration_no: element.car_registration_no,
          });
        });
        this.setState({
          car_registration_no_list: car,
          styleCarRegis: styleCarRegis,
        });

        if (
          result.data.length === 0 &&
          data[index].car_registration_no !== ""
        ) {
          styleCarRegis[index] = "has-warning";
          data[index]["work_no"] = "";
          this.setState({ styleCarRegis: styleCarRegis });
        }
      }
    );
  }

  loadRecordCategory() {
    let { cashflowCate, cashflowCateAuto, perm } = this.state;
    let that = this;
    CashflowStore.loadRecordCategory(function (result) {
      cashflowCate.push({
        label: "ทั้งหมด",
        value: "",
      });
      result.data.forEach(function (item, index) {
        cashflowCate.push({
          label: item.Name,
          value: item.Value,
        });
        cashflowCateAuto.push({
          label: item.Name,
          value: item.Value,
        });
      });

      if (result.perm !== undefined) perm = result.perm;

      that.setState({
        cashflowCate: cashflowCate,
        cashflowCateAuto: cashflowCateAuto,
        perm: perm,
      });
    });
  }

  loadCompany() {
    let { companyAuto } = this.state;
    CashflowStore.loadCompany((result) => {
      result.data.forEach(function (item, index) {
        companyAuto.push({
          label: item.Name,
          value: item.Value,
        });
      });

      this.setState({ companyAuto: companyAuto });
    });
  }

  loadCashflowRecord(
    defaultYear = "",
    defaultMonth = "",
    defaultDay = "",
    cashflowValue = ""
  ) {
    let that = this;
    let { styleCarRegis } = this.state;
    styleCarRegis = [];
    this.setState({
      loading: true,
      optionsDay: this.getOptionsDay(defaultYear, defaultMonth),
    });
    CashflowStore.loadCashflowRecord(
      defaultYear - 543,
      defaultMonth,
      defaultDay,
      cashflowValue,
      function (result) {
        result.data.forEach(function (item, index) {
          result.data[index] = Object.assign(item, {
            usage_date: item.cash_date,
          });
          result.data[index] = Object.assign({ is_clear: "0" }, item);
          styleCarRegis[index] =
            result.data[index]["work_no"] === "" ? "has-warning" : "";
        });
        let data = that.setItemlist(result.data);
        data = data.map((item, index) => {
          if (item.cashflow_record_id > 0)
            item = Object.assign({ dateEdit: false }, item);
          return item;
        });
        that.setState({
          loading: false,
          data: data,
          styleCarRegis: styleCarRegis,
        });
      }
    );
    if (this.props.isReport)
      this.setState({
        defaultYear: defaultYear,
        defaultMonth: defaultMonth,
        defaultDay: defaultDay,
      });
  }

  loadDataRange(start, end, cashflowValue) {
    this.setState({ loading: true });
    let { styleCarRegis } = this.state;
    styleCarRegis = [];
    CashflowStore.loadCashflowRecordRange(
      start,
      end,
      cashflowValue,
      (result) => {
        result.data.forEach((item, index) => {
          result.data[index] = Object.assign(item, {
            usage_date: item.cash_date,
          });
          styleCarRegis[index] =
            result.data[index]["work_no"] === "" ? "has-warning" : "";
        });
        let data = this.setItemlist(result.data);
        data = data.map((item, index) => {
          if (item.cashflow_record_id > 0)
            item = Object.assign({ dateEdit: false }, item);
          return item;
        });
        this.setState({
          loading: false,
          data: data,
          styleCarRegis: styleCarRegis,
        });
      }
    );
  }

  newEmptyRow(number = 1) {
    let {
      defaultYear,
      defaultMonth,
      defaultDay,
      styleCarRegis,
      isRange,
      defaultDayRange,
      defaultMonthRange,
      defaultYearRange,
    } = this.state;
    return new Array(number).fill(null).map((item, index) => {
      styleCarRegis.push("has-warning");
      let curY = Moment().format("YYYY") * 1;
      let curM = Moment().format("MM") * 1;
      let usage_date = "";
      if (defaultDay == 0) {
        if (curY == (defaultYear - 543) * 1 && curM == defaultMonth * 1) {
          usage_date =
            defaultYear -
            543 +
            "-" +
            defaultMonth +
            "-" +
            Moment().format("DD");
        } else {
          usage_date =
            defaultYear -
            543 +
            "-" +
            defaultMonth +
            "-" +
            Moment().format("DD");
        }
      } else {
        if (isRange)
          usage_date =
            defaultYearRange -
            543 +
            "-" +
            defaultMonthRange +
            "-" +
            defaultDayRange;
        else
          usage_date =
            defaultYear - 543 + "-" + defaultMonth + "-" + defaultDay;
      }

      return {
        work_no: "",
        car_registration_no: "",
        usage_date: usage_date,
        added_by: "",
        added_date: "",
        cash_date: usage_date,
        cashflow_record_id: "",
        category: "",
        description: "",
        money_received: "",
        money_spent: "",
        remark: "",
        company: "",
        is_clear: "0",
        document: [],
      };
    });
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth();
    const optionsDay = [];

    if (all_day) {
      for (var i = 0; i <= all_day; i++) {
        if (i == 0) {
          var label = "ทั้งเดือน";
        } else {
          var label = i;
        }
        optionsDay.push({
          value: i,
          label: label,
        });
      }
      if (all_day < this.state.defaultDay) {
        var defaultDay = 0;
      } else {
        var defaultDay = this.state.defaultDay;
      }
    } else {
      optionsDay.push({
        value: 0,
        label: "ทั้งเดือน",
      });
      var defaultDay = 0;
    }

    this.setState({ optionsDay: optionsDay, defaultDay: defaultDay });
    return defaultDay;
  }

  onYearChange(e) {
    let { defaultYear, defaultMonth, cashflowValue } = this.state;
    defaultYear = e.value;

    let date = defaultYear - 543 + "-" + this.state.defaultMonth;
    let curDay = 0;
    curDay = this.getAllDayOfMonth(date);

    this.setState({
      defaultYear: e.value,
      defaultDay: curDay,
      isRange: false,
      activeIndex: [],
    });
    this.loadCashflowRecord(e.value, defaultMonth, curDay, cashflowValue);
  }

  onMonthChange(e) {
    let { defaultYear, cashflowValue } = this.state;
    let date = this.state.defaultYear - 543 + "-" + e.value;
    let curDay = 0;
    curDay = this.getAllDayOfMonth(date);

    this.setState({
      defaultMonth: e.value,
      defaultDay: curDay,
      isRange: false,
      activeIndex: [],
    });
    this.loadCashflowRecord(defaultYear, e.value, curDay, cashflowValue);
  }

  onSearchDayChange(e) {
    let { defaultYear, defaultMonth, cashflowValue } = this.state;
    this.setState({ defaultDay: e.value, isRange: false, activeIndex: [] });
    this.loadCashflowRecord(defaultYear, defaultMonth, e.value, cashflowValue);
  }

  onDateChange(index, e) {
    let { defaultYear, defaultMonth, data, activeIndex } = this.state;
    let day = e.substr(0, 2);
    data[index].cash_date = defaultYear - 543 + "-" + defaultMonth + "-" + day;
    data[index].usage_date = defaultYear - 543 + "-" + defaultMonth + "-" + day;
    if (activeIndex.indexOf(index) === -1) activeIndex.push(index);
    this.setState({ data: data, activeIndex: activeIndex });
  }

  onIconDayChange(e) {
    if (e != "" && e != undefined && e != null) {
      let { cashflowValue } = this.state;
      let day = parseInt(e.substr(0, 2));
      let month = parseInt(e.substr(3, 5));
      let year = parseInt(e.substr(6, 10));
      this.setState({
        defaultDay: day,
        defaultMonth: month,
        defaultYear: year,
        defaultDayRange: day,
        defaultMonthRange: month,
        defaultYearRange: year,
        isRange: false,
        activeIndex: [],
      });
      this.loadCashflowRecord(year, month, day, cashflowValue);
    }
  }

  onDayChange(index, e) {
    let { defaultYear, defaultMonth, data, activeIndex } = this.state;
    data[index].cash_date =
      defaultYear - 543 + "-" + defaultMonth + "-" + e.value;
    data[index].usage_date =
      defaultYear - 543 + "-" + defaultMonth + "-" + e.value;
    if (activeIndex.indexOf(index) === -1) activeIndex.push(index);
    this.setState({ data: data, activeIndex: activeIndex });
    ReactDOM.findDOMNode(this._description[index]).focus();
    this.setTableAuto();
  }

  onSearchSelect(e) {
    let { defaultYear, defaultMonth, defaultDay } = this.state;
    this.setState({ cashflowValue: e.value, isRange: false, activeIndex: [] });
    this.loadCashflowRecord(defaultYear, defaultMonth, defaultDay, e.value);
  }

  onTextChange(index, key, e) {
    let { data, styleCarRegis, activeIndex } = this.state;
    if (key === "car_registration_no") {
      data[index][key] = e.target.value;
      this.setState({ data: data });
      this.loadCarRegistrationNo(index);
      if (data[index][key] === "") {
        styleCarRegis[index] = "";
        data[index]["work_no"] = "";
        this.setState({ styleCarRegis: styleCarRegis });
      }
    } else {
      data[index][key] = e.target.value;
      this.setState({ data: data });
    }
    if (activeIndex.indexOf(index) === -1) activeIndex.push(index);
    this.setState({ activeIndex: activeIndex });
  }

  onNumericChange(index, key, e) {
    let { data, activeIndex } = this.state;
    data[index][key] = e;
    if (activeIndex.indexOf(index) === -1) activeIndex.push(index);
    this.setState({ data: data, activeIndex: activeIndex });
  }

  onTextFocus(index, key, e) {
    this.loadCarRegistrationNo(index);
  }

  onTextSelect(index, key, e, eitem) {
    let { data, activeIndex } = this.state;
    if (key == "car_registration_no") {
      data[index]["car_registration_no"] = eitem.car_registration_no;
      data[index]["work_no"] = eitem.work_no;
      this.setState({ data: data });
    } else if (key == "category") {
      data[index]["category"] = e.value;
      this.setState({ data: data }, () => {
        // $('.table-responsive').css( "overflow-x", "auto" );
      });
    } else if (key == "company") {
      data[index]["company"] = e.value;
      this.setState({ data: data });
    }
    if (activeIndex.indexOf(index) === -1) activeIndex.push(index);
    this.setState({ activeIndex: activeIndex });
    this.setTableAuto();
  }

  onDeleteClick(index) {
    let fieldInfo = {
      title: "โปรดระบุเหตุผลในการลบข้อมูล",
      index: index,
      value: "",
    };
    this.refs.textFieldModal.loadInfo(fieldInfo);
  }

  onDelConfirm(info) {
    let { data, deletedData, styleCarRegis, activeIndex } = this.state;
    let item = data.splice(info.index, 1);
    if (item[0].cashflow_record_id !== "") {
      item[0] = Object.assign({ reason_to_delete: info.value }, item[0]);
      deletedData.push(item[0]);
    }
    styleCarRegis[info.index] = "";
    if (activeIndex.indexOf(info.index) !== -1)
      activeIndex.splice(activeIndex.indexOf(info.index), 1);
    this.setState(
      {
        data: data,
        deletedData: deletedData,
        styleCarRegis: styleCarRegis,
        activeIndex: activeIndex,
      },
      () => {
        this.onSaveClick(0);
      }
    );
  }

  onTextNewCateChange(e) {
    this.setState({ newCate: e.target.value });
  }

  onTextNewCompanyChange(e) {
    this.setState({ newCompany: e.target.value });
  }

  onSaveNewCateClick() {
    let {
      data,
      newCate,
      cashflowCate,
      cashflowCateAuto,
      cateAction,
      indexCategory,
    } = this.state;
    if (cateAction == "add") {
      let isValid = cashflowCateAuto.find((item, index) => {
        return item.value == newCate;
      });

      if (isValid != undefined) {
        this._notificationSystem.addNotification({
          title: "แจ้งเตือน",
          message: "มีหมวดหมู่นี้อยู่แล้ว !",
          level: "error",
          position: "tc",
        });
        return false;
      }

      let postData = { category_name: newCate };
      CashflowStore.saveRecordCategory(postData, (result) => {
        if (result.status === "OK") {
          this._notificationSystem.addNotification({
            title: "แจ้งเตือน",
            message: "ทำการบันทึกเรียบร้อย",
            level: "info",
            position: "tc",
          });
          cashflowCate.push({
            label: newCate,
            value: newCate,
          });
          cashflowCateAuto.push({
            label: newCate,
            value: newCate,
          });

          this.setState({
            showAddCate: false,
            newCate: "",
            cashflowCate: cashflowCate,
            cashflowCateAuto: cashflowCateAuto,
            cateAction: "add",
          });
        }
      });
    } else {
      let isValid = cashflowCateAuto.find((item, index) => {
        return item.value == newCate && index != indexCategory;
      });

      if (isValid != undefined) {
        this._notificationSystem.addNotification({
          title: "แจ้งเตือน",
          message: "มีหมวดหมู่นี้อยู่แล้ว !",
          level: "error",
          position: "tc",
        });
        return false;
      }

      let postData = {
        old_category: cashflowCateAuto[indexCategory].label,
        new_category: newCate,
      };
      CashflowStore.updateRecordCategory(
        postData,
        (result) => {
          if (result.status == "OK") {
            this._notificationSystem.addNotification({
              title: "แจ้งเตือน",
              message: "ทำการบันทึกเรียบร้อย",
              level: "info",
              position: "tc",
            });

            let newData = [];
            newData = data.map((item, index) => {
              if (item.category == cashflowCateAuto[indexCategory].value)
                data[index].category = newCate;

              return data[index];
            });

            cashflowCate[indexCategory + 1].label = newCate;
            cashflowCate[indexCategory + 1].value = newCate;
            cashflowCateAuto[indexCategory].label = newCate;
            cashflowCateAuto[indexCategory].value = newCate;
            this.setState({
              data: newData,
              showAddCate: false,
              newCate: "",
              cateAction: "add",
              indexCategory: undefined,
              cashflowCate: cashflowCate,
              cashflowCateAuto: cashflowCateAuto,
            });
          }
        },
        (fail) => {
          this.setState({
            showAddCate: false,
            newCate: "",
            cateAction: "add",
            indexCategory: undefined,
          });
        }
      );
    }
  }

  onSaveNewCompanyClick() {
    let {
      data,
      newCompany,
      companyAuto,
      companyAction,
      indexCompany,
    } = this.state;
    if (companyAction == "add") {
      let isValid = companyAuto.find((item, index) => {
        return item.value == newCompany;
      });

      if (isValid != undefined) {
        this._notificationSystem.addNotification({
          title: "แจ้งเตือน",
          message: "มีบริษัทนี้อยู่แล้ว !",
          level: "error",
          position: "tc",
        });
        return false;
      }

      let postData = { company_name: newCompany };
      CashflowStore.saveCompany(postData, (result) => {
        if (result.status === "OK") {
          this._notificationSystem.addNotification({
            title: "แจ้งเตือน",
            message: "ทำการบันทึกเรียบร้อย",
            level: "info",
            position: "tc",
          });
          companyAuto.push({
            label: newCompany,
            value: newCompany,
          });

          this.setState({
            showAddCompany: false,
            newCompany: "",
            companyAuto: companyAuto,
          });
        }
      });
    } else {
      let isValid = companyAuto.find((item, index) => {
        return item.value == newCompany && index != indexCompany;
      });

      if (isValid != undefined) {
        this._notificationSystem.addNotification({
          title: "แจ้งเตือน",
          message: "มีบริษัทนี้อยู่แล้ว !",
          level: "error",
          position: "tc",
        });
        return false;
      }

      let postData = {
        old_company: companyAuto[indexCompany].label,
        new_company: newCompany,
      };
      CashflowStore.updateCompany(
        postData,
        (result) => {
          if (result.status == "OK") {
            this._notificationSystem.addNotification({
              title: "แจ้งเตือน",
              message: "ทำการบันทึกเรียบร้อย",
              level: "info",
              position: "tc",
            });

            let newData = [];
            newData = data.map((item, index) => {
              if (item.company == companyAuto[indexCompany].value)
                data[index].company = newCompany;

              return data[index];
            });

            companyAuto[indexCompany].label = newCompany;
            companyAuto[indexCompany].value = newCompany;
            this.setState({
              data: newData,
              showAddCompany: false,
              newCompany: "",
              companyAction: "add",
              indexCompany: undefined,
              companyAuto: companyAuto,
            });
          }
        },
        (fail) => {
          this.setState({
            showAddCompany: false,
            newCompany: "",
            companyAction: "add",
            indexCompany: undefined,
          });
        }
      );
    }
  }

  getUsageDay(usageDate) {
    if (usageDate === "") return 1;
    let uM = Moment(usageDate, "YYYY-MM-DD");

    return uM.format("DD") * 1;
  }

  onCarSearchSelect(e) {
    let { data, car_index, activeIndex } = this.state;
    data[car_index]["car_registration_no"] =
      typeof e.car_registration_no !== "undefined"
        ? e.car_registration_no
        : e.Value;
    data[car_index]["work_no"] = e.work_no;
    if (activeIndex.indexOf(car_index) === -1) activeIndex.push(car_index);
    this.setState({ data: data, activeIndex: activeIndex });
    this.loadCarRegistrationNo(car_index);
  }

  onIsClearChange(index) {
    let { data } = this.state;
    if (data[index].is_clear == "0") data[index].is_clear = "1";
    else data[index].is_clear = "0";

    this.setState({ data: data });
  }

  onUploadClick(itemnumdoc, title, name, e) {
    let url = "";
    if (process.env.NODE_ENV === "development") {
      url =
        "https://demo2.bigfix.co/korat/fup/cf.html?cf=" +
        itemnumdoc +
        "&cat=" +
        name +
        "&title=" +
        title;
    } else {
      url =
        "./fup/cf.html?cf=" + itemnumdoc + "&cat=" + name + "&title=" + title;
    }
    this.refs.iframeUpload.loadUrl(url);
  }

  onUpImgHide(itemnumdoc) {
    this.onSyncDocumentDetail(itemnumdoc);
  }

  onNewDocChange(e) {
    this.setState({ newDoc: e.target.value });
  }

  onDocSaveClick() {
    let { dataDoc, newDoc, itemnumdoc, isAction, indexEdit } = this.state;

    if (newDoc === "") return false;

    if (isAction === "add") {
      let nubmer = "";
      if (dataDoc.length == 0) nubmer = 1;
      else nubmer = dataDoc.length + 1;

      if (dataDoc.length < 9) nubmer = "0" + nubmer;

      dataDoc.push({
        name: nubmer,
        title: newDoc,
        icon: "file-text-o",
        color: "lightgray",
        total_count: 0,
      });
    } else {
      dataDoc[indexEdit].title = newDoc;
    }
    let postData = { cf: itemnumdoc, document: dataDoc };
    CashflowStore.saveDocumentDetail(
      postData,
      (result) => {
        if (result.status === "OK") {
          this._notificationSystem.addNotification({
            title: "แจ้งเตือน",
            message: "ทำการบันทึกเอกสารเรียบร้อย",
            level: "info",
            position: "tc",
          });
          this.setState({
            showAddDoc: false,
            newDoc: "",
            dataDoc: dataDoc,
            isAction: "add",
            indexEdit: undefined,
          });
        }
      },
      () => {
        this.setState({
          showAddDoc: false,
          newDoc: "",
          isAction: "add",
          indexEdit: undefined,
        });
      }
    );
  }

  onDocTitleClick(item) {
    let { itemnumdoc, docActive } = this.state;
    docActive.name = item.name;
    docActive.title = item.title;
    this.setState({ docActive: docActive });
    CashflowStore.loadDocumentFile(
      itemnumdoc,
      item.name,
      (result) => {
        this.setState({ dataImg: result.data });
      },
      () => {}
    );
  }

  onShowDocEdit() {
    let { isShowDocEdit } = this.state;
    if (isShowDocEdit) isShowDocEdit = false;
    else isShowDocEdit = true;

    this.setState({ isShowDocEdit: isShowDocEdit });
  }

  onEditDocClick(item, index) {
    let { newDoc } = this.state;
    newDoc = item.title;
    this.setState({
      showAddDoc: true,
      newDoc: newDoc,
      isAction: "edit",
      indexEdit: index,
    });
  }

  onDocDelClick(index) {
    this.setState({ showConfirm: true, indexDel: index });
  }

  onDeleteItemClick() {
    let {
      data,
      dataDoc,
      itemnumdoc,
      docActive,
      dataImg,
      indexDel,
    } = this.state;
    CashflowStore.delDocumentDetail(
      itemnumdoc,
      dataDoc[indexDel].name,
      (result) => {
        if (result.status == "OK") {
          if (docActive.name === dataDoc[indexDel].name) {
            docActive.name = undefined;
            docActive.title = undefined;
            dataImg.files = [];
          }
          setTimeout(() => {
            dataDoc.splice(indexDel, 1);
            let dataIndex = data.findIndex(
              (x) => x.cashflow_record_id === itemnumdoc
            );
            if (dataIndex != -1) {
              data[dataIndex].document = dataDoc;
              data[dataIndex].document = dataDoc.map((item, index) => {
                return Object.assign(
                  { icon: "file-text-o", color: "lightgray" },
                  data[dataIndex].document[index]
                );
              });
            }
            this.setState({
              dataDoc: dataDoc,
              docActive: docActive,
              dataImg: dataImg,
              data: data,
              showConfirm: false,
              indexDel: undefined,
            });
          }, 100);
        }
      },
      () => {
        this.setState({ showConfirm: false, indexDel: undefined });
      }
    );
  }

  onDocHide() {
    let { itemnumdoc } = this.state;
    this.onSyncDocumentDetail(itemnumdoc, (result) => {
      if (result === "OK")
        this.setState({
          dataImg: { files: [] },
          showDoc: false,
          itemnumdoc: undefined,
          docActive: { name: undefined, title: undefined },
        });
    });
  }

  onSyncDocumentDetail(itemnumdoc, complete) {
    let { data, dataDoc, docActive, activeIndex } = this.state;
    let dataIndex = data.findIndex((x) => x.cashflow_record_id === itemnumdoc);
    this.onDocTitleClick(docActive);
    CashflowStore.syncDocumentDetail(
      itemnumdoc,
      (result) => {
        if (activeIndex.indexOf(dataIndex) === -1) activeIndex.push(dataIndex);

        dataDoc = result.data;
        data[dataIndex].document = result.data;
        data[dataIndex].document = result.data.map((item, index) => {
          return Object.assign(
            {
              icon: "file-text-o",
              color:
                activeIndex.indexOf(dataIndex) !== -1 ? "#333" : "lightgray",
            },
            data[dataIndex].document[index]
          );
        });
        this.setState({
          dataDoc: dataDoc,
          data: data,
          activeIndex: activeIndex,
        });
        if (complete !== undefined) complete("OK");
      },
      () => {}
    );
  }

  onLoadDocumentDetail(item) {
    CashflowStore.loadDocumentDetail(
      item.cashflow_record_id,
      (result) => {
        this.setState({
          showDoc: true,
          dataDoc: result.data,
          itemnumdoc: item.cashflow_record_id,
        });
      },
      () => {}
    );
  }

  onShowDocClick(item, index) {
    this.onLoadDocumentDetail(item);
  }

  // onMenuOpen() {
  //   $('.table-responsive').css( "overflow-x", "initial" );
  // }

  onDateEditClick(index, val) {
    let { data } = this.state;
    data[index].dateEdit = val;
    this.setState({ data: data });
  }

  renderGroupHeadRowData(cash_date) {
    return (
      <tr style={{ backgroundColor: "#eee" }}>
        <td colSpan={11}>{cash_date}</td>
      </tr>
    );
  }

  renderRowData() {
    let {
      data,
      defaultDay,
      defaultMonth,
      defaultYear,
      cashflowCateAuto,
      perm,
      companyAuto,
      isRange,
      isIncome,
      isExpense,
      activeIndex,
    } = this.state;
    let isAdminDisabled = false;
    let date_select = defaultDay + "/" + defaultMonth + "/" + defaultYear;
    let _today = curDay + "/" + curMonth + "/" + yTh;

    // if (!perm.perm_cashflow_admin) {
    //   if (date_select!==_today)
    //     isAdminDisabled = true
    // }

    let colSpan = 11;
    if (!isIncome && !isExpense) colSpan = 9;
    else if (!isIncome || !isExpense) colSpan = 10;
    else colSpan = 11;

    let isNoData = true;
    data.forEach((item, index) => {
      if (!item.isHide) isNoData = false;
    });
    if (data === undefined || data.length === 0 || isNoData) {
      return (
        <tr>
          <td colSpan={colSpan}>ไม่พบข้อมูล</td>
        </tr>
      );
    } else {
      let days = [];
      let checkDupMonth = "";
      this.state.optionsDay.forEach(function (item, index) {
        if (item.value > 0) days.push(item);
      });
      let row_number = 0;
      return data.map((item, index) => {
        let uDay = this.getUsageDay(item.cash_date);
        let today = uDay + "/" + defaultMonth + "/" + defaultYear;
        let isDisabled = false;

        // if (!perm.perm_cashflow_admin) {
        //   if (_today===today)
        //     isDisabled = false
        //   else
        //     isDisabled = true
        // }

        if (
          item.cashflow_record_id !== undefined &&
          item.cashflow_record_id * 1 === -1
        ) {
          isDisabled = true;
        }
        isDisabled = isDisabled || isAdminDisabled;

        /* GROUP MONTH */
        let _cash_date = item.cash_date.split("-");
        let _month = "";
        let showGroupHead = false;
        if (_cash_date.length > 0) _month = _cash_date[1];

        if (index == 0) {
          showGroupHead = true;
        } else {
          if (checkDupMonth != _month) showGroupHead = true;
        }
        checkDupMonth = _month;

        if (!item.isHide) row_number++;
        return [
          isRange && showGroupHead
            ? this.renderGroupHeadRowData(momentHelper.getMonthText(_month))
            : "",
          <tr
            key={index}
            style={{ display: item.isHide ? "none" : "" }}
            className={activeIndex.indexOf(index) !== -1 ? "bg-gray" : ""}
          >
            <td className="text-center" style={{ verticalAlign: "middle" }}>
              {row_number}
            </td>
            <td style={{ verticalAlign: "middle" }}>
              <Select
                className="inline-table w-calendar"
                clearable={false}
                disabled={
                  item.dateEdit ? false : uDay === defaultDay || isDisabled
                }
                name="form-field-name"
                value={uDay}
                options={days}
                onChange={this.onDayChange.bind(this, index)}
              />
              <DatePicker
                style={{ display: "inline-block", top: "4px" }}
                wSelect={true}
                disabledCalendarIcon={
                  item.dateEdit ? false : uDay === defaultDay || isDisabled
                }
                height={"36px"}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement="bottom"
                buddhistEra
                value={today}
                onChange={this.onDateChange.bind(this, index)}
                maxWidth={"100%"}
              />
              &nbsp;
              {typeof item.dateEdit !== "undefined" &&
              (uDay === defaultDay || isDisabled) ? (
                <FontAwesome
                  onClick={this.onDateEditClick.bind(
                    this,
                    index,
                    !item.dateEdit
                  )}
                  style={{ cursor: "pointer" }}
                  name="pencil"
                />
              ) : (
                ""
              )}
            </td>
            <td className="text-center">
              <FormControl
                disabled={isDisabled}
                value={item.description}
                onChange={this.onTextChange.bind(this, index, "description")}
                ref={(input) => {
                  this._description[index] = input;
                }}
              />
            </td>
            {isIncome ? (
              <td className="text-center">
                <InputNumber
                  disabled={isDisabled}
                  className="input-number-format"
                  value={item.money_received}
                  onChange={this.onNumericChange.bind(
                    this,
                    index,
                    "money_received"
                  )}
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                />
              </td>
            ) : (
              ""
            )}
            {isExpense ? (
              <td className="text-center">
                <InputNumber
                  disabled={isDisabled}
                  className="input-number-format"
                  value={item.money_spent}
                  onChange={this.onNumericChange.bind(
                    this,
                    index,
                    "money_spent"
                  )}
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                />
              </td>
            ) : (
              ""
            )}
            <td className="text-center">
              <FormGroup className={this.state.styleCarRegis[index]}>
                <InputGroup>
                  <CKAutocomplete
                    ref={(input) => {
                      this.pcInput[index] = input;
                    }}
                    disabled={isDisabled}
                    choiceStyle={{ width: "350px" }}
                    items={this.state.car_registration_no_list}
                    value={item.car_registration_no}
                    workNo={item.work_no}
                    onChange={this.onTextChange.bind(
                      this,
                      index,
                      "car_registration_no"
                    )}
                    onSelect={this.onTextSelect.bind(
                      this,
                      index,
                      "car_registration_no"
                    )}
                    onFocus={this.onTextFocus.bind(
                      this,
                      index,
                      "car_registration_no"
                    )}
                    inTable={true}
                  />
                  <InputGroup.Addon
                    style={{ pointerEvents: isDisabled ? "none" : "unset" }}
                    disabled={isDisabled}
                    className="btn"
                    onClick={() =>
                      this.setState({ showCar: true, car_index: index })
                    }
                  >
                    <FontAwesome name="plus" />
                  </InputGroup.Addon>
                </InputGroup>
              </FormGroup>
            </td>
            <td>
              <Select
                disabled={isDisabled}
                clearable={false}
                value={item.category}
                options={cashflowCateAuto}
                style={{ minWidth: "100px", maxWidth: "170px" }}
                placeholder="เลือกรายการ..."
                onChange={this.onTextSelect.bind(this, index, "category")}
                // onOpen={this.onMenuOpen.bind(this)}
              />
            </td>
            <td>
              <Select
                disabled={isDisabled}
                clearable={false}
                value={item.company}
                options={companyAuto}
                style={{ minWidth: "100px", maxWidth: "170px" }}
                placeholder="เลือกรายการ..."
                onChange={this.onTextSelect.bind(this, index, "company")}
              />
            </td>
            <td>
              <FormControl
                disabled={isDisabled}
                value={item.remark === null ? "" : item.remark}
                onChange={this.onTextChange.bind(this, index, "remark")}
              />
            </td>
            {this.renderDocument(
              item,
              index,
              activeIndex.indexOf(index) !== -1 ? 1 : 0
            )}
            <td className="text-center">
              <Button
                bsStyle="danger"
                disabled={isDisabled}
                onClick={this.onDeleteClick.bind(this, index)}
              >
                <FontAwesome name="trash" />
              </Button>
            </td>
          </tr>,
        ];
      });
    }
  }

  renderDocument(item, index, is_change) {
    return (
      <td className="text-center">
        {item.document.map((sitem, sindex) => {
          const tooltip = (
            <Tooltip id="tooltip">
              <strong>{sitem.title}</strong>
            </Tooltip>
          );
          return (
            <span
              onClick={this.onUploadClick.bind(
                this,
                item.cashflow_record_id,
                sitem.title,
                sitem.name
              )}
              style={{
                position: "relative",
                cursor: "pointer",
                margin: "0 5px 0 5px",
                display: sitem.total_count > 0 ? "" : "none",
              }}
              key={sindex}
            >
              <span
                style={{
                  position: "absolute",
                  top: "-10px",
                  right: "-7px",
                  fontSize: "10px",
                  borderRadius: "100%",
                }}
                className="label label-danger"
              >
                {sitem.total_count}
              </span>
              <OverlayTrigger placement="top" overlay={tooltip}>
                <FontAwesome
                  name={sitem.icon}
                  style={{
                    color: is_change ? "#333" : sitem.color,
                    fontSize: "20px",
                  }}
                />
              </OverlayTrigger>
            </span>
          );
        })}
        {item.cashflow_record_id !== "-1" &&
        item.cashflow_record_id !== "" &&
        item.cashflow_record_id !== null &&
        item.cashflow_record_id !== undefined ? (
          <Button
            onClick={this.onShowDocClick.bind(this, item, index)}
            bsSize="xs"
          >
            <FontAwesome name="plus" />
          </Button>
        ) : (
          ""
        )}
      </td>
    );
  }

  renderExportRowData() {
    let { data, isRange } = this.state;
    if (data === undefined || data.length === 0) {
      return (
        <tr>
          <td colSpan={10}>ไม่พบข้อมูล</td>
        </tr>
      );
    } else {
      let checkDupMonth = "";
      let number = 0;
      return data.map((item, index) => {
        if (!item.isHide) {
          number++;
          let uDay = this.getUsageDay(item.cash_date);

          /* GROUP MONTH */
          let _cash_date = item.cash_date.split("-");
          let _month = "";
          let showGroupHead = false;
          if (_cash_date.length > 0) _month = _cash_date[1];

          if (index == 0) {
            showGroupHead = true;
          } else {
            if (checkDupMonth != _month) showGroupHead = true;
          }
          checkDupMonth = _month;
          return [
            isRange && showGroupHead
              ? this.renderGroupHeadRowData(momentHelper.getMonthText(_month))
              : "",
            <tr key={index}>
              <td className="text-center">{number}</td>
              <td className="text-center">{uDay}</td>
              <td className="text-center">{item.description}</td>
              <td className="text-center">
                {this.getNumberFormat(item.money_received)}
              </td>
              <td className="text-center">
                {this.getNumberFormat(item.money_spent)}
              </td>
              <td className="text-center">{item.car_registration_no}</td>
              <td className="text-center">{item.category}</td>
              <td className="text-center">{item.company}</td>
              <td>{item.remark}</td>
            </tr>,
          ];
        }
      });
    }
  }

  onRowAdd(number) {
    let { data } = this.state;
    data = data.concat(this.newEmptyRow(number));

    this.pcInput = new Array(data.length).fill("");
    this.setState({ data: data });
  }

  renderNewItemButton() {
    let { is_search } = this.state;
    if (is_search) {
      return <div />;
    } else
      return (
        <Row style={{ marginTop: "10px" }}>
          <Col md={12}>
            <ButtonToolbar>
              <Button
                className="bg-olive"
                onClick={this.onRowAdd.bind(this, 1)}
              >
                <FontAwesome name="plus" />
                &nbsp;เพิ่มรายการ
              </Button>
              <Button
                className="bg-olive"
                onClick={this.onRowAdd.bind(this, 10)}
              >
                <FontAwesome name="plus" />
                &nbsp;เพิ่ม 10 รายการ
              </Button>
            </ButtonToolbar>
          </Col>
        </Row>
      );
  }

  onSaveClick(is_close = 0, e) {
    let that = this;
    let { data, deletedData, activeIndex, isSave } = this.state;
    let _data = JSON.parse(JSON.stringify(data));
    if (isSave) {
      this.setState({ isSave: false }, () => {
        let itemlist = _data.reduce((rresult, item, index) => {
          if (activeIndex.indexOf(index) !== -1) {
            if (typeof item.dateEdit !== "undefined") delete item["dateEdit"];

            rresult.push(item);
          }
          return rresult;
        }, []);
        if (itemlist.length === 0 && deletedData.length === 0) {
          this.setState({ isSave: true });
          return false;
        }
        let postData = { itemlist: itemlist, deleted_item: deletedData };
        this.setState({ loading: true });
        CashflowStore.saveCashflowRecord(
          postData,
          function (result) {
            if (result.status === "OK") {
              that.refs.notificationSystem.addNotification({
                title: "แจ้งเตือน",
                message: "ทำการบันทึกเรียบร้อย",
                level: "info",
                position: "tc",
              });
              // let newItem = data.map((item,index)=>{
              //   let indexItem = result.data.findIndex(x=>x.cashflow_record_id===item.cashflow_record_id)
              //   if (indexItem!==-1) {
              //     item = result.data[indexItem]
              //   }
              //   if (item.cashflow_record_id>0)
              //     item = Object.assign({dateEdit:false},item)
              //   return item
              // })
              let newItem = JSON.parse(JSON.stringify(data)).reduce(
                (rresult, item, index) => {
                  if (item.cashflow_record_id) rresult.push(item);
                  return rresult;
                },
                []
              );
              result.data.forEach((item, index) => {
                let indexItem = newItem.findIndex(
                  (x) => x.cashflow_record_id === item.cashflow_record_id
                );
                if (item.cashflow_record_id > 0)
                  item = Object.assign({ dateEdit: false }, item);
                if (indexItem !== -1) {
                  newItem[indexItem] = item;
                } else {
                  newItem.push(item);
                }
              });
              that.setState(
                {
                  loading: false,
                  data: newItem,
                  activeIndex: [],
                  deletedData: [],
                  isSave: true,
                  showCancel: false,
                },
                () => {
                  if (is_close) that.onReportClose();
                }
              );
            } else {
              that.setState({
                loading: false,
                isSave: true,
                showCancel: false,
              });
            }
          },
          function () {
            that.setState({ loading: false, isSave: true, showCancel: false });
          }
        );
      });
    }
  }

  onExportExcel(e) {
    const worksheet = XLSX.utils.table_to_book(
      document.getElementById(this.refTableId)
    );
    let wbout = XLSX.write(worksheet, {
      bookType: "xlsx",
      bookSST: true,
      type: "binary",
    });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    }
    const fileName = "รายการรายรับ-รายจ่าย.xlsx";
    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: "application/octet-stream" }),
      fileName
    );
    this.setState({ showExport: false });
  }

  onPrintClick() {
    let url = "";
    let {
      defaultDay,
      defaultMonth,
      defaultYear,
      cashflowValue,
      isIncome,
      isExpense,
    } = this.state;

    if (process.env.NODE_ENV == "development") {
      url =
        "./?startPage=PrintReportCashflowRecord&cat=" +
        cashflowValue +
        "&year=" +
        defaultYear +
        "&month=" +
        defaultMonth +
        "&day=" +
        defaultDay +
        "&money_received=" +
        isIncome +
        "&money_spent=" +
        isExpense;
    } else {
      url =
        "./pdf/v2/?startPage=PrintReportCashflowRecord&cat=" +
        cashflowValue +
        "&year=" +
        defaultYear +
        "&month=" +
        defaultMonth +
        "&day=" +
        defaultDay +
        "&money_received=" +
        isIncome +
        "&money_spent=" +
        isExpense;
    }
    this.refs.iframe.loadUrl(url);
  }

  onReportClose() {
    this.setState({ showCancel: false }, () => {
      this.props.onReportClose();
    });
  }

  onEndDateRangeChange(e) {
    if (e != "" && e != undefined && e != null) {
      let { defaultDay, defaultMonth, defaultYear, cashflowValue } = this.state;
      let day = parseInt(e.substr(0, 2));
      let month = parseInt(e.substr(3, 5));
      let year = parseInt(e.substr(6, 10));
      this.setState({
        isRange: true,
        defaultDayRange: day,
        defaultMonthRange: month,
        defaultYearRange: year,
        activeIndex: [],
      });
      defaultYear = defaultYear - 543;
      year = year - 543;
      let start =
        (defaultDay == 0 ? 1 : defaultDay) +
        "/" +
        defaultMonth +
        "/" +
        defaultYear;
      let end = day + "/" + month + "/" + year;
      this.loadDataRange(start, end, cashflowValue);
    }
  }

  onRangeClearClick() {
    let { defaultMonth, defaultYear, cashflowValue } = this.state;

    let date = this.state.defaultYear - 543 + "-" + defaultMonth;
    let curDay = 0;
    curDay = this.getAllDayOfMonth(date);

    this.loadCashflowRecord(defaultYear, defaultMonth, curDay, cashflowValue);
    this.setState({
      isRange: false,
      defaultDayRange: curDay,
      defaultMonthRange: defaultMonth,
      defaultYearRange: defaultYear,
      activeIndex: [],
    });
  }

  onIncomeClick() {
    let { isIncome, data } = this.state;
    if (isIncome) isIncome = false;
    else isIncome = true;

    this.setState({ isIncome: isIncome }, () => {
      this.setState({ data: this.setItemlist(data) });
    });
  }

  onExpenseClick() {
    let { isExpense, data } = this.state;
    if (isExpense) isExpense = false;
    else isExpense = true;

    this.setState({ isExpense: isExpense }, () => {
      this.setState({ data: this.setItemlist(data) });
    });
  }

  setItemlist(data) {
    let { isIncome, isExpense } = this.state;
    data = data.map((item, index) => {
      delete item["isHide"];
      return item;
    });
    if (isIncome && !isExpense) {
      data = data.map((item, index) => {
        if (item.money_received * 1 > 0) {
        } else {
          item = Object.assign({ isHide: true }, item);
        }
        return item;
      });
    } else if (!isIncome && isExpense) {
      data = data.map((item, index) => {
        if (item.money_spent * 1 > 0) {
        } else {
          item = Object.assign({ isHide: true }, item);
        }
        return item;
      });
    } else if (!isIncome && !isExpense) {
      data = data.map((item, index) => {
        item = Object.assign({ isHide: true }, item);
        return item;
      });
    }
    return data;
  }

  renderTable() {
    const mRecv = this.getMoneyReceived();
    const mSpent = this.getMoneySpent();
    const mBalance = mRecv - mSpent;
    let { perm, isIncome, isExpense } = this.state;
    return (
      <div className="table-responsive">
        <table
          className="table table-hover table-bordered-solid table-tool"
          style={{ marginBottom: "0", minWidth: "1800px" }}
        >
          <thead>
            <tr>
              <th className="text-center" style={{ width: "30px" }}>
                ลำดับ
              </th>
              <th
                className="text-center"
                style={{ width: "120px", minWidth: "120px" }}
              >
                วันที่
              </th>
              <th className="text-center" style={{ width: "300px" }}>
                รายการ
              </th>
              {isIncome ? (
                <th
                  className="text-center text-green"
                  style={{ width: "120px" }}
                >
                  รายรับ
                </th>
              ) : (
                ""
              )}
              {isExpense ? (
                <th className="text-center text-red" style={{ width: "150px" }}>
                  รายจ่าย
                </th>
              ) : (
                ""
              )}
              <th className="text-center" style={{ width: "150px" }}>
                ทะเบียนรถ
              </th>
              <th className="text-center" style={{ width: "150px" }}>
                หมวดหมู่{" "}
                <span
                  style={{
                    cursor: "pointer",
                    display: !perm.perm_add_category ? "none" : "",
                  }}
                  onClick={() => {
                    this.setState({ showCate: true });
                  }}
                >
                  <FontAwesome className="text-green" name="plus" />
                </span>
              </th>
              <th className="text-center" style={{ width: "150px" }}>
                บริษัท{" "}
                <span
                  style={{
                    cursor: "pointer",
                    display: !perm.perm_add_category ? "none" : "",
                  }}
                  onClick={() => {
                    this.setState({ showCompany: true });
                  }}
                >
                  <FontAwesome className="text-blue" name="plus" />
                </span>
              </th>
              <th className="text-center" style={{ width: "200px" }}>
                หมายเหตุ
              </th>
              <th className="text-center" style={{ width: "100px" }}>
                ไฟล์เอกสาร
              </th>
              <th className="text-center" style={{ width: "30px" }}>
                ลบ ?
              </th>
            </tr>
          </thead>
          <tbody>{this.renderRowData()}</tbody>
          <tfoot>
            <tr>
              <th className="text-center" colSpan={3}></th>
              {isIncome ? (
                <th className="text-right">{this.getNumberFormat(mRecv)}</th>
              ) : (
                ""
              )}
              {isExpense ? (
                <th className="text-right">{this.getNumberFormat(mSpent)}</th>
              ) : (
                ""
              )}
              {isIncome && isExpense ? (
                <th className="text-right">
                  คงเหลือ {this.getNumberFormat(mBalance)}
                </th>
              ) : (
                ""
              )}
              <th
                className="text-center"
                colSpan={
                  isIncome && isExpense ? 5 : !isIncome && !isExpense ? 6 : 6
                }
              >
                {!isIncome && !isExpense ? <br /> : ""}
              </th>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  }

  renderExportTable() {
    let { defaultDay, defaultMonth, defaultYear, isRange } = this.state;
    const mRecv = this.getMoneyReceived();
    const mSpent = this.getMoneySpent();
    const mBalance = mRecv - mSpent;

    return (
      <div className="table-responsive" style={{ display: "none" }}>
        <table
          id={this.refTableId}
          className="table table-hover table-bordered-solid table-tool"
          style={{ marginBottom: "0", minWidth: "1024px" }}
        >
          <thead>
            <tr>
              {isRange ? (
                <th colSpan={10}>
                  รายการรายรับ-รายจ่าย ประจำวันที่{" "}
                  {this.getStartDateRangeText()} - {this.getEndDateRangeText()}
                </th>
              ) : (
                <th colSpan={10}>
                  {defaultDay == 0
                    ? "รายการรายรับ-รายจ่าย ประจำเดือน " +
                      momentHelper.getMonthText(defaultMonth.toString()) +
                      " " +
                      defaultYear
                    : "รายการรายรับ-รายจ่าย ประจำวันที่ " +
                      defaultDay +
                      " เดือน " +
                      momentHelper.getMonthText(defaultMonth.toString()) +
                      " " +
                      defaultYear}
                </th>
              )}
            </tr>
            <tr>
              <th className="text-center" style={{ width: "30px" }}>
                ลำดับ
              </th>
              <th
                className="text-center"
                style={{ width: "120px", minWidth: "120px" }}
              >
                วันที่
              </th>
              <th className="text-center" style={{ width: "300px" }}>
                รายการ
              </th>
              <th className="text-center text-green" style={{ width: "120px" }}>
                รายรับ
              </th>
              <th className="text-center text-red" style={{ width: "150px" }}>
                รายจ่าย
              </th>
              <th className="text-center" style={{ width: "150px" }}>
                ทะเบียนรถ
              </th>
              <th className="text-center" style={{ width: "150px" }}>
                หมวดหมู่
              </th>
              <th className="text-center" style={{ width: "150px" }}>
                บริษัท
              </th>
              <th className="text-center" style={{ width: "200px" }}>
                หมายเหตุ
              </th>
            </tr>
          </thead>
          <tbody>{this.renderExportRowData()}</tbody>
          <tfoot>
            <tr>
              <th className="text-center" colSpan={4}></th>
              <th className="text-right">{this.getNumberFormat(mRecv)}</th>
              <th className="text-right">{this.getNumberFormat(mSpent)}</th>
              <th className="text-right" colSpan={2}>
                คงเหลือ {this.getNumberFormat(mBalance)}
              </th>
              <th className="text-center" colSpan={3}></th>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  }

  getNumberFormat(value) {
    let _val =
      value === "" || value === null || value === undefined || isNaN(value)
        ? 0
        : value;
    _val = parseFloat(_val);
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
  }

  getMoneyReceived(isClear = false) {
    let { data } = this.state;
    let sum = 0;
    data.forEach(function (item, index) {
      let money_received = item.money_received;
      money_received =
        money_received === ""
          ? 0
          : money_received === null
          ? 0
          : money_received === undefined
          ? 0
          : isNaN(money_received)
          ? 0
          : money_received;
      if ((isClear && item.is_clear == "1") || !isClear)
        sum = parseFloat(sum) + parseFloat(money_received);
    });
    return sum;
  }

  getMoneySpent(isClear = false) {
    let { data } = this.state;
    let sum = 0;
    data.forEach(function (item, index) {
      let money_spent = item.money_spent;
      money_spent =
        money_spent === ""
          ? 0
          : money_spent === null
          ? 0
          : money_spent === undefined
          ? 0
          : isNaN(money_spent)
          ? 0
          : money_spent;
      if ((isClear && item.is_clear == "1") || !isClear)
        sum = parseFloat(sum) + parseFloat(money_spent);
    });
    return sum;
  }

  getStartDateRangeText() {
    let { defaultDay, defaultMonth, defaultYear } = this.state;
    defaultDay = defaultDay == 0 ? 1 : defaultDay;
    let txtMonth = momentHelper.getMonthText(defaultMonth.toString());
    return defaultDay + " " + txtMonth + " " + defaultYear;
  }

  getEndDateRangeText() {
    let { defaultDayRange, defaultMonthRange, defaultYearRange } = this.state;
    defaultDayRange = defaultDayRange == 0 ? 1 : defaultDayRange;
    let txtMonth = momentHelper.getMonthText(defaultMonthRange.toString());
    return defaultDayRange + " " + txtMonth + " " + defaultYearRange;
  }

  renderRowDataCategory() {
    let { cashflowCateAuto } = this.state;
    if (cashflowCateAuto.length == 0) {
      return (
        <tr>
          <td colSpan={3}>ไม่พบข้อมูล</td>
        </tr>
      );
    } else {
      return cashflowCateAuto.map((item, index) => (
        <tr key={index}>
          <td className="text-center">{index + 1}</td>
          <td>{item.label}</td>
          <td className="text-center">
            <button
              className="btn btn-default"
              onClick={() => {
                this.setState({
                  showAddCate: true,
                  newCate: item.label,
                  cateAction: "edit",
                  indexCategory: index,
                });
              }}
            >
              แก้ไข
            </button>
          </td>
        </tr>
      ));
    }
  }

  renderTableCategory() {
    return (
      <div className="table-responsive">
        <table className="table table-bordered-solid">
          <thead>
            <tr>
              <th className="text-center" style={{ width: "5%" }}>
                ลำดับ
              </th>
              <th className="text-center" style={{ width: "70%" }}>
                หมวดหมู่
              </th>
              <th className="text-center" style={{ width: "25%" }}></th>
            </tr>
          </thead>
          <tbody>{this.renderRowDataCategory()}</tbody>
        </table>
      </div>
    );
  }

  renderCategoryModal() {
    let { showCate, showAddCate, newCate, cateAction } = this.state;
    return [
      <Modal
        key={"modal-category"}
        show={showCate}
        onHide={() => this.setState({ showCate: false })}
      >
        <Modal.Header closeButton>
          <Modal.Title>หมวดหมู่</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-right">
            <Button
              bsStyle={"link"}
              onClick={() => {
                this.setState({ showAddCate: true });
              }}
            >
              <FontAwesome name="plus" /> เพิ่มหมวดหมู่
            </Button>
          </div>
          {this.renderTableCategory()}
        </Modal.Body>
      </Modal>,
      <Modal
        key={"modal-add-category"}
        show={showAddCate}
        onHide={() =>
          this.setState({
            showAddCate: false,
            newCate: "",
            cateAction: "add",
            indexCategory: undefined,
          })
        }
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {cateAction == "add" ? "เพิ่มหมวดหมู่" : "แก้ไขหมวดหมู่"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup controlId="formBasicText" validationState={null}>
            <ControlLabel>หมวดหมู่</ControlLabel>
            <FormControl
              type="text"
              value={newCate}
              onChange={this.onTextNewCateChange.bind(this)}
            />
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn-primary"
            onClick={this.onSaveNewCateClick.bind(this)}
          >
            <FontAwesome name="save" />
            &nbsp;บันทึก
          </Button>
          <Button
            onClick={() =>
              this.setState({
                showAddCate: false,
                newCate: "",
                cateAction: "add",
                indexCategory: undefined,
              })
            }
          >
            <FontAwesome name="close" />
            &nbsp;ปิด
          </Button>
        </Modal.Footer>
      </Modal>,
    ];
  }

  renderRowDataCompany() {
    let { companyAuto } = this.state;

    if (companyAuto.length == 0) {
      return (
        <tr>
          <td colSpan={3}>ไม่พบข้อมูล</td>
        </tr>
      );
    } else {
      return companyAuto.map((item, index) => (
        <tr key={index}>
          <td className="text-center">{index + 1}</td>
          <td>{item.label}</td>
          <td className="text-center">
            <button
              className="btn btn-default"
              onClick={() => {
                this.setState({
                  showAddCompany: true,
                  newCompany: item.label,
                  companyAction: "edit",
                  indexCompany: index,
                });
              }}
            >
              แก้ไข
            </button>
          </td>
        </tr>
      ));
    }
  }

  renderTableCompany() {
    return (
      <div className="table-responsive">
        <table className="table table-bordered-solid">
          <thead>
            <tr>
              <th className="text-center" style={{ width: "5%" }}>
                ลำดับ
              </th>
              <th className="text-center" style={{ width: "70%" }}>
                บริษัท
              </th>
              <th className="text-center" style={{ width: "25%" }}></th>
            </tr>
          </thead>
          <tbody>{this.renderRowDataCompany()}</tbody>
        </table>
      </div>
    );
  }

  renderCompanyModal() {
    let { showCompany, showAddCompany, newCompany, companyAction } = this.state;
    return [
      <Modal
        key={"modal-company"}
        show={showCompany}
        onHide={() => this.setState({ showCompany: false })}
      >
        <Modal.Header closeButton>
          <Modal.Title>บริษัท</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-right">
            <Button
              bsStyle={"link"}
              onClick={() => {
                this.setState({ showAddCompany: true });
              }}
            >
              <FontAwesome name="plus" /> เพิ่มบริษัท
            </Button>
          </div>
          {this.renderTableCompany()}
        </Modal.Body>
      </Modal>,
      <Modal
        key={"modal-add-company"}
        show={showAddCompany}
        onHide={() =>
          this.setState({
            showAddCompany: false,
            newCompany: "",
            companyAction: "add",
            indexCompany: undefined,
          })
        }
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {companyAction == "add" ? "เพิ่มบริษัท" : "แก้ไขบริษัท"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup controlId="formBasicText" validationState={null}>
            <ControlLabel>บริษัท</ControlLabel>
            <FormControl
              type="text"
              value={newCompany}
              onChange={this.onTextNewCompanyChange.bind(this)}
            />
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn-primary"
            onClick={this.onSaveNewCompanyClick.bind(this)}
          >
            <FontAwesome name="save" />
            &nbsp;บันทึก
          </Button>
          <Button
            onClick={() =>
              this.setState({
                showAddCompany: false,
                newCompany: "",
                companyAction: "add",
                indexCompany: undefined,
              })
            }
          >
            <FontAwesome name="close" />
            &nbsp;ปิด
          </Button>
        </Modal.Footer>
      </Modal>,
    ];
  }

  renderDocName(dataDoc) {
    let { isShowDocEdit } = this.state;
    if (dataDoc.length === 0) {
      return (
        <tr>
          <td colSpan={2}>ไม่พบข้อมูล</td>
        </tr>
      );
    } else {
      return dataDoc.map((item, index) => {
        return (
          <tr key={index}>
            <td>
              <a
                style={{ cursor: "pointer" }}
                onClick={this.onDocTitleClick.bind(this, item)}
              >
                {item.title}
              </a>
              &nbsp;
              <FontAwesome
                style={{
                  cursor: "pointer",
                  display: isShowDocEdit ? "" : "none",
                }}
                name="pencil"
                onClick={this.onEditDocClick.bind(this, item, index)}
              />
            </td>
            <td className="text-right">
              <Button
                style={{ display: isShowDocEdit ? "" : "none" }}
                bsSize="xsmall"
                className="pull-right"
                bsStyle={"danger"}
                onClick={this.onDocDelClick.bind(this, index)}
              >
                <FontAwesome name="minus" />
              </Button>
            </td>
          </tr>
        );
      });
    }
  }

  renderDocThumbnai(dataImg) {
    if (dataImg.files.length === 0) {
      return (
        <tr>
          <td
            colSpan={2}
            className="text-center"
            style={{ border: "2px dashed #ddd", verticalAlign: "middle" }}
          >
            ...
          </td>
        </tr>
      );
    } else {
      return (
        <tr>
          <td
            colSpan={2}
            className="text-center"
            style={{ border: "2px dashed #ddd" }}
          >
            <Row>
              {dataImg.files.map((item, index) => {
                return (
                  <Col md={6} key={index}>
                    <img src={item.thumbnailUrl} />
                  </Col>
                );
              })}
            </Row>
          </td>
        </tr>
      );
    }
  }

  renderBodyModalDoc() {
    let { dataDoc, dataImg, itemnumdoc, docActive } = this.state;
    return (
      <Row>
        <Col md={6}>
          <table className="table table-responsive table-hover">
            <thead>
              <tr>
                <th>ชื่อเอกสาร</th>
                <th className="text-right">
                  <Button
                    onClick={() => this.setState({ showAddDoc: true })}
                    className="btn btn-xs"
                  >
                    <FontAwesome name="plus" />
                  </Button>
                  &nbsp;
                  <Button
                    onClick={this.onShowDocEdit.bind(this)}
                    className="btn btn-xs"
                  >
                    <FontAwesome name="pencil" />
                  </Button>
                </th>
              </tr>
            </thead>
            <tbody>{this.renderDocName(dataDoc)}</tbody>
          </table>
        </Col>
        <Col md={6}>
          <table className="table table-responsive table-hover">
            <thead>
              <tr>
                <th style={{ borderBottom: "none" }}>Thumbnail</th>
                <th style={{ borderBottom: "none" }} className="text-right">
                  {docActive.title !== undefined && docActive.name !== undefined
                    ? "เลือก - " + docActive.title + " "
                    : ""}
                  <Button
                    disabled={
                      docActive.title !== undefined &&
                      docActive.name !== undefined
                        ? false
                        : true
                    }
                    onClick={this.onUploadClick.bind(
                      this,
                      itemnumdoc,
                      docActive.title,
                      docActive.name
                    )}
                    className="btn btn-xs"
                  >
                    <FontAwesome name="plus" />
                  </Button>
                </th>
              </tr>
            </thead>
            <tbody>{this.renderDocThumbnai(dataImg)}</tbody>
          </table>
        </Col>
      </Row>
    );
  }

  renderModalDoc() {
    let { showDoc } = this.state;
    return (
      <Modal
        show={showDoc}
        onHide={this.onDocHide.bind(this)}
        dialogClassName="smallwidth-dialog"
      >
        <Modal.Header closeButton>
          <Modal.Title>ไฟล์เอกสาร</Modal.Title>
        </Modal.Header>
        <Modal.Body>{this.renderBodyModalDoc()}</Modal.Body>
      </Modal>
    );
  }

  renderModalAddDoc() {
    let { showAddDoc, newDoc } = this.state;
    return (
      <Modal
        show={showAddDoc}
        onHide={() =>
          this.setState({
            showAddDoc: false,
            newDoc: "",
            isAction: "add",
            indexEdit: undefined,
          })
        }
        dialogClassName="smallwidth-dialog"
      >
        <Modal.Header closeButton>
          <Modal.Title>เพิ่มเอกสารไฟล์เอกสาร</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form horizontal>
            <FormGroup>
              <Col componentClass={ControlLabel} sm={3}>
                ชื่อเอกสาร
              </Col>
              <Col sm={8}>
                <FormControl
                  value={newDoc}
                  onChange={this.onNewDocChange.bind(this)}
                />
              </Col>
            </FormGroup>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="primary" onClick={this.onDocSaveClick.bind(this)}>
            <FontAwesome name="save" /> บันทึกรายการ
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderBtnSave() {
    let { isSave } = this.state;
    return [
      <Button
        key={0}
        bsStyle="primary"
        disabled={isSave ? false : true}
        onClick={this.onSaveClick.bind(this, 1)}
      >
        <FontAwesome name="save" />
        &nbsp;บันทึก
      </Button>,
      <Button key={1} onClick={this.onReportClose.bind(this)}>
        <FontAwesome name="close" />
        &nbsp;ไม่ต้องการ
      </Button>,
    ];
  }

  render() {
    let {
      loading,
      cashflowCate,
      cashflowValue,
      perm,
      defaultMonth,
      defaultYear,
      isIncome,
      isExpense,
      isSave,
      activeIndex,
      deletedData,
    } = this.state;
    let date_select = defaultMonth + "/" + defaultYear;
    let _today = curMonth + "/" + yTh;

    var style = {
      NotificationItem: {
        DefaultStyle: {
          margin: "10px 5px 2px 1px",
          fontSize: "30px",
          width: "400px",
          textAlign: "center",
        },
      },
    };
    return (
      <Box loading={loading}>
        <Box.Header>
          <Box.Title>รายการรายรับ-รายจ่าย</Box.Title>
          <Box.Tools>
            <Button
              className="bg-green"
              onClick={this.onExportExcel.bind(this)}
            >
              <FontAwesome name="file-excel-o" />
              &nbsp;ออกไฟล์ Excel
            </Button>{" "}
            <Button
              className="bg-maroon"
              onClick={this.onPrintClick.bind(this)}
            >
              <FontAwesome name="print" />
              &nbsp;พิมพ์เอกสาร
            </Button>
          </Box.Tools>
        </Box.Header>
        <Box.Body>
          <Row style={{ marginBottom: this.state.isRange ? "" : "5px" }}>
            <Col md={12}>
              <Form inline>
                <FormGroup>
                  <Select
                    clearable={false}
                    name="form-field-name"
                    value={this.state.defaultYear}
                    options={this.state.optionsYear}
                    style={{ width: "80px" }}
                    onChange={this.onYearChange.bind(this)}
                  />
                </FormGroup>{" "}
                <FormGroup>
                  <Select
                    clearable={false}
                    name="form-field-name"
                    value={this.state.defaultMonth}
                    options={this.state.optionsMonth}
                    style={{ width: "120px" }}
                    onChange={this.onMonthChange.bind(this)}
                  />
                </FormGroup>{" "}
                <FormGroup style={{ display: "inline-flex" }}>
                  <Select
                    className="inline-table w-calendar"
                    clearable={false}
                    name="form-field-name"
                    value={this.state.defaultDay}
                    style={{ width: "90px" }}
                    options={this.state.optionsDay}
                    onChange={this.onSearchDayChange.bind(this)}
                  />
                  <DatePicker
                    style={{ display: "inline-block" }}
                    height={"36px"}
                    none={true}
                    showIcon={true}
                    showFooter={true}
                    popPlacement="bottom"
                    buddhistEra
                    value={
                      (this.state.defaultDay === 0 ||
                      this.state.defaultDayRange === "0"
                        ? 1
                        : this.state.defaultDayRange) +
                      "/" +
                      this.state.defaultMonth +
                      "/" +
                      this.state.defaultYear
                    }
                    onChange={this.onIconDayChange.bind(this)}
                    maxWidth={"100%"}
                  />
                  <DatePicker
                    style={{ display: "inline-block" }}
                    height={"36px"}
                    none={true}
                    showIcon={true}
                    showFooter={true}
                    popPlacement="bottom"
                    buddhistEra
                    value={
                      this.state.defaultDayRange +
                      "/" +
                      this.state.defaultMonthRange +
                      "/" +
                      this.state.defaultYearRange
                    }
                    onChange={this.onEndDateRangeChange.bind(this)}
                    maxWidth={"100%"}
                  />
                </FormGroup>{" "}
                <FormGroup>
                  <Select
                    clearable={false}
                    name="form-field-name"
                    value={cashflowValue}
                    options={cashflowCate}
                    style={{ width: "170px" }}
                    placeholder="เลือกรายการ..."
                    onChange={this.onSearchSelect.bind(this)}
                  />
                </FormGroup>{" "}
                <FormGroup>
                  <Button
                    bsStyle={isIncome ? "success" : "default"}
                    active={isIncome ? false : true}
                    onClick={this.onIncomeClick.bind(this)}
                  >
                    <FontAwesome name="check" />
                    &nbsp;รายรับ
                  </Button>
                </FormGroup>{" "}
                <FormGroup>
                  <Button
                    bsStyle={isExpense ? "danger" : "default"}
                    active={isExpense ? false : true}
                    onClick={this.onExpenseClick.bind(this)}
                  >
                    <FontAwesome name="check" />
                    &nbsp;รายจ่าย
                  </Button>
                </FormGroup>
              </Form>
            </Col>
          </Row>
          <Row
            style={{
              marginTop: "10px",
              marginBottom: "5px",
              display: this.state.isRange ? "" : "none",
            }}
          >
            <Col md={12}>
              <div style={{ display: "flex" }}>
                {this.getStartDateRangeText()} - {this.getEndDateRangeText()}
                &nbsp;
                <Button
                  className="btn btn-xs"
                  onClick={this.onRangeClearClick.bind(this)}
                >
                  <FontAwesome name="eraser" />
                  &nbsp;ลบช่วงเวลา
                </Button>
              </div>
            </Col>
          </Row>
          {this.renderTable()}
          {this.renderExportTable()}
          {date_select !== _today && !perm.perm_cashflow_admin
            ? ""
            : this.renderNewItemButton()}
        </Box.Body>
        <Box.Footer>
          <ButtonToolbar className="pull-right">
            <Button
              disabled={isSave ? false : true}
              style={{
                display:
                  date_select !== _today && !perm.perm_cashflow_admin
                    ? "none"
                    : "",
              }}
              bsStyle="primary"
              onClick={this.onSaveClick.bind(this, 0)}
            >
              <FontAwesome name="save" />
              &nbsp;บันทึก
            </Button>
            <Button
              style={{ display: this.props.isReport ? "" : "none" }}
              onClick={
                activeIndex.length > 0 || deletedData.length > 0
                  ? () => {
                      this.setState({ showCancel: true });
                    }
                  : this.onReportClose.bind(this)
              }
            >
              <FontAwesome name="close" />
              &nbsp;ปิด
            </Button>
          </ButtonToolbar>
        </Box.Footer>
        <SearchCarButton
          show={this.state.showCar}
          onHide={() => {
            this.setState({ showCar: false });
          }}
          onSelect={this.onCarSearchSelect.bind(this)}
        />
        <NotificationSystem ref="notificationSystem" style={style} />
        <IframeModal ref="iframe" title={"พิมพ์เอกสาร"} />
        {/* Modal Category */}
        {this.renderCategoryModal()}
        {/* Modal Category */}
        {/* Modal Company */}
        {this.renderCompanyModal()}
        {/* Modal Company */}
        {this.renderModalDoc()}
        {this.renderModalAddDoc()}
        <IframeModal
          ref="iframeUpload"
          title="อับโหลดรูป"
          modal={true}
          param={"cf"}
          onUpImgHide={this.onUpImgHide.bind(this)}
          returnId={true}
        />
        <ConfirmPopup
          show={this.state.showConfirm}
          message={"ยืนยันการลบรายการ ?"}
          onConfirm={this.onDeleteItemClick.bind(this)}
          onHide={() =>
            this.setState({ showConfirm: false, indexDel: undefined })
          }
        />
        <ConfirmPopup
          show={this.state.showCancel}
          message={"มีรายการแก้ไขที่รอการบันทึก ต้องการบันทึกหรือไม่ ?"}
          renderOptionBtn={this.renderBtnSave.bind(this)}
          onHide={() => this.setState({ showCancel: false })}
          hideBtn={false}
        />
        <TextFieldModal
          ref="textFieldModal"
          confirmTitle="ยันยันลบรายการ"
          isValid={true}
          onConfirm={this.onDelConfirm.bind(this)}
        />
      </Box>
    );
  }
}

CashFlowRecord.defaultProps = {
  isReport: false,
  stockType: "officemate",
  show: false,
};

export default CashFlowRecord;



// WEBPACK FOOTER //
// ./src/view/cashflow/CashFlowRecord.js